import { QRCodeCanvas } from "qrcode.react";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { Dialog } from "../../core/Dialog/Dialog";
import { Typography } from "../../core/Typography/Typography";
import { useStyles } from "./ControllerQRCodeDialog.style";
import { OTHER_CONTROLLERS_FAQ_URL } from "../../../constants/controllerInstruction";
import { useTranslation } from "react-i18next";

type TControllerQRCodeDialog = {
  onClose?: () => void;
  open: boolean;
};

const ControllerQRCodeDialog: React.FC<TControllerQRCodeDialog> = (props) => {
  const { open, onClose } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      mainAction={{
        text: t("Dialog_Ok"),
        onClick: onClose,
        id: "close-dialog",
        "data-gamepad": "default-selected",
        size: "large",
      }}
      className={classes.dialog}
    >
      <div className={classes.otherControllersContent}>
        <Typography
          variant={TypographyVariant.HeadingH3Bold}
          color={TypographyColor.Default}
        >
          {t("Controller_Connection Guide")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB3Medium}
          color={TypographyColor.Default}
        >
          {t(
            "Controller_Please scan the QR code below to learn more about how to connect with controllers",
          )}
        </Typography>
        <QRCodeCanvas
          value={OTHER_CONTROLLERS_FAQ_URL}
          size={138}
          className={classes.qrCode}
          level="L"
          marginSize={3}
        />
      </div>
    </Dialog>
  );
};

export default ControllerQRCodeDialog;
